<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :hot-key-create-path="`/intake-bin/create`"
    :formsConfig="formsConfig"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Intake Bins" />
    </template>
    <div>
      <gc-filter-split-view
        :showLeftContainer="showFilterLeftContainer"
        :showRightContainer="showFilterRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :height="gridHeight"
            :dataSource="dataSourceConfig"
            :columns="columns"
            @toolbar-preparing="onToolbarPreparing($event)"
            :ref="'intake-bin-list'"
            :column-chooser="{
              enabled: true,
              allowSearch: true,
              mode: 'select',
              height: '100%',
              width: 300,
            }"
            @content-ready="addGridNoResults($event)"
          >
            <DxExport :enabled="true" :file-name="'IntakeBinList'" />
            <template #active-cell-template="{ data }">
              <GcStatusActive :status="data.data.FriendlyActive" />
            </template>

            <template #product-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.ProductName"
                :code="data.data.ProductCode"
              />
            </template>
            <template #branch-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.BranchName"
                :code="data.data.BranchCode"
              />
            </template>

            <template #site-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.SiteName"
                :code="data.data.SiteCode"
              />
            </template>
            <template #location-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.LocationName"
                :code="data.data.LocationCode"
              />
            </template>
            <template #menu-cell-template="{ data }">
              <DxDropDownButton
                :items="[{ menuText: 'Transfer Bin', data: data }]"
                keyExpr="menuText"
                displayExpr="menuText"
                :drop-down-options="{ width: 250 }"
                class="gc-dropdown-icon-button"
                :id="data.data.BinCardNo"
                :icon="binListContextMenu.icon"
                styling-mode="text"
                :show-arrow-icon="false"
                :onItemClick="onBinListContextMenuItemClick"
              />
            </template>
          </dx-data-grid>

          <DxPopup
            :visible.sync="transferBinPopupVisible"
            :drag-enabled="false"
            :hide-on-outside-click="true"
            :show-title="true"
            title="Create Stock Transfer"
            :showCloseButton="false"
            :height="750"
            @hidden="transferBinHidden"
          >
            <DxToolbar class="transfer-bin-toolbar">
              <DxItem #default location="after" locate-in-menu="auto">
                <gc-status-chip :status="'New'" />
              </DxItem>
            </DxToolbar>
            <div class="transfer-bin-form">
              <DxForm
                :read-only="false"
                :form-data.sync="transferBinModel"
                :show-colon-after-label="false"
                :show-validation-summary="false"
                :validation-group="formsConfig.validationGroup"
                :label-location="formsConfig.labelPosition"
                :items="transferBinFormItems"
                :show-required-mark="false"
              >
                <template #item-template="{ data }">
                  <GcAutoCompleteItemTemplate
                    :description="data.Description"
                    :code="data.Code"
                  />
                </template>
              </DxForm>
            </div>
            <dx-data-grid
              :data-source="transferBinDataSourceConfig"
              :height="350"
              :columns="transferBinColumns"
              ref="transferBinGrid"
              :column-chooser="{ enabled: false }"
            >
              <template #product-cell-template="{ data }">
                <GcDescriptionCodeCellTemplate
                  :description="data.data.ProductName"
                  :code="data.data.ProductCode"
                />
              </template>

              <template #site-cell-template="{ data }">
                <GcDescriptionCodeCellTemplate
                  :description="data.data.SiteName"
                  :code="data.data.SiteCode"
                />
              </template>
              <template #location-cell-template="{ data }">
                <GcDescriptionCodeCellTemplate
                  :description="data.data.LocationName"
                  :code="data.data.LocationCode"
                />
              </template>
            </dx-data-grid>

            <div class="footer-actions">
              <DxButton
                class="action-button"
                text="Transfer Bin"
                type="default"
                styling-mode="contained"
                @click="transferBin"
              />
              <DxButton
                class="action-button"
                text="Back"
                type="normal"
                styling-mode="contained"
                @click="popUpBackButtonClick"
              />
            </div>
          </DxPopup>
        </template>
        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :filterFormHeight="filterFormHeight"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :screenType="'intake-bin-list'"
            :data-source-config="dataSourceConfig"
          >
            <!-- :filterCallBack="applyFilter" -->
            <!-- :advanceFilterArray="advanceFilterArray" -->
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { DxExport } from "devextreme-vue/data-grid";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { IntakeBinListService } from "../../_services/api/inventory/intake-bin-list.service";
import { tabAccessControl } from "../../_helpers/access-control";
import DxToolbar from "devextreme-vue/toolbar";
import { alert } from "devextreme/ui/dialog";
import { CustomerService } from "../../_services/api/customers/customer.service";

let branchDataSource = CustomerService.dataSourceConfig("api/Branch", {
  filter: [["Inactive", "=", "N"]],
  sort: [{ selector: "Description", asc: true }],
});

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      transferBinPopupVisible: false,
      transferBinDataSourceConfig: [],
      branchDataSourceConfig: [],
      gridRefName: "intake-bin-list",
      // advanceFilterArray: [],
      rowSelect: {
        view: this,
        page: "intake-bin",
        mode: "review",
        idProperty: "BinCode",
      },
      // showLeftContainer: true,
      // showRightContainer: false,
      // filterToolbar: {
      //   close: {
      //     icon: "showpanel",
      //     onClick: () => {
      //       this.showRightContainer = !this.showRightContainer;
      //       var item = document.getElementById("filter-btn");
      //       item.classList.remove("dx-state-invisible");
      //       // var grid = this.$refs["intake-bin-list"].instance;
      //       // grid.repaint();
      //     },
      //   },
      //   clear: {
      //     text: "Clear",
      //     onClick: () => {},
      //   },
      // },
      model: {
        CompanyCode: "",
        BranchCode: "",
        DivisionCode: "",
      },

      transferBinModel: {
        DateIn: new Date(),
        FromBranch: "",
        ToBranch: "",
      },
      // filterFormHeight: "auto",
      // sideBarTabs: [
      //   {
      //     id: 0,
      //     text: "Filters",
      //   },
      // ],
      advanceFilterModel: {
        SeasonYear: "",
        BinCardNoAsString: [],
        BranchCode: [],
        ProductCode: [],
        LocationCode: [],
        SiteCode: [],
        Grade: [],
        // FiscalYear: undefined,
        // FiscalPeriod: undefined,
      },
      binListContextMenu: {
        icon: "overflow",
      },
    };
  },
  components: { DxExport, DxToolbar },
  async created() {
    this.selectedIndex = 0;
    let result = await DefaultCompanyBranchDivisionService.getDefault();
    // eslint-disable-next-line no-console
    console.log("Default");
    if (result.data.value.length > 0) {
      this.model.CompanyCode = result.data.value[0].CompanyCode;
      this.model.BranchCode = result.data.value[0].BranchCode;
      this.model.DivisionCode = result.data.value[0].DivisionCode;
    }
  },
  computed: {
    transferBinFormItems() {
      let items = [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              itemType: "group",
              caption: "",
              items: this.parseFormColumns([
                {
                  dataField: "DateIn",
                  gcLabel: "Date In",
                  gcType: "Date",
                  required: true,
                  editorOptions: {
                    readOnly: true,
                  },
                },
                {
                  dataField: "FromBranch",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  gcLabel: "From Branch",
                  readOnly: true,
                  editorOptions: {
                    dataSource: CustomerService.dataSourceConfig("api/Branch", {
                      filter: [["Inactive", "=", "N"]],
                      sort: [{ selector: "Description", asc: true }],
                    }),
                    valueExpr: "Code",
                    displayExpr: "Description",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    searchEnabled: true,
                    itemTemplate: "item-template",
                  },
                },
                {
                  dataField: "ToBranch",
                  gcType: "String",
                  editorType: "dxSelectBox",
                  gcLabel: "To Branch",

                  editorOptions: {
                    allowEditing: true,
                    dataSource: this.branchDataSourceConfig,
                    valueExpr: "Code",
                    displayExpr: "Description",
                    searchExpr: ["Code", "Description"],
                    searchMode: "contains",
                    searchEnabled: true,
                    itemTemplate: "item-template",
                  },
                },
              ]),
            },
          ],
        },
      ];

      return items;
    },
    transferBinColumns() {
      return this.parseGridColumns("transaction", [
        {
          gcLabel: "Season",
          gcType: "String-TransactionNo",
          dataField: "SeasonYear",
          sortOrder: "asc",
        },
        {
          gcLabel: "Card",
          gcType: "String",
          gcSubType: "PrimaryTransactionNo",
          dataField: "BinCardNoAsString",
          sortOrder: "asc",
          calculateSortValue: "BinCardNo",
          width: 120,
          sortIndex: 1,
        },

        {
          gcLabel: "Product",
          dataField: "ProductCode",
          cellTemplate: "product-cell-template",
          width: 220,
          gcType: "String",
          gcSubType: "RelatedRecord",
          gcExport: ["ProductCode", "ProductName"],
        },

        {
          gcLabel: "Product Code",
          dataField: "ProductCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Product Name",
          dataField: "ProductName",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },

        {
          gcLabel: "Location",
          dataField: "LocationCode",
          cellTemplate: "location-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["LocationCode", "LocationName"],
        },
        {
          gcLabel: "Location Code",
          gcType: "String",
          dataField: "LocationCode",
          sortOrder: "asc",
          width: 120,
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Location Name",
          gcType: "String",
          dataField: "LocationName",
          width: 140,
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Site",
          dataField: "SiteCode",
          cellTemplate: "site-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["SiteCode", "SiteName"],
        },
        {
          gcLabel: "Site Code",
          gcType: "String",
          dataField: "SiteCode",
          sortOrder: "asc",
          width: 120,
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Site Name",
          gcType: "String",
          dataField: "SiteName",
          width: 140,
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Net Kg",
          dataField: "NetWeight",
          gcType: "String",
          width: 200,
        },
      ]);
    },
    tabs() {
      var tabs = [
        {
          text: "In Stock",
          path: `/intake-bin`,
          applicationFeatureCode: "IntakeBins",
        },
      ];

      return tabAccessControl(tabs);
    },
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Card",
          gcType: "String",
          gcSubType: "PrimaryTransactionNo",
          dataField: "BinCardNoAsString",
          sortOrder: "asc",
          calculateSortValue: "BinCardNo",
          width: 120,
        },
        {
          gcLabel: "Season",
          gcType: "String-TransactionNo",
          dataField: "SeasonYear",
          sortOrder: "asc",
        },
        {
          gcLabel: "Branch",
          dataField: "BranchCode",
          cellTemplate: "branch-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["BranchCode", "BranchName"],
        },

        {
          gcLabel: "Branch Code",
          dataField: "BranchCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Branch Name",
          dataField: "BranchName",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Product",
          dataField: "ProductCode",
          cellTemplate: "product-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["ProductCode", "ProductName"],
        },

        {
          gcLabel: "Product Code",
          dataField: "ProductCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Product Name",
          dataField: "ProductName",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Location",
          dataField: "LocationCode",
          cellTemplate: "location-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["LocationCode", "LocationName"],
        },
        {
          gcLabel: "Location Code",
          gcType: "String",
          dataField: "LocationCode",
          sortOrder: "asc",
          width: 120,
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Location Name",
          gcType: "String",
          dataField: "LocationName",
          width: 140,
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Site",
          dataField: "SiteCode",
          cellTemplate: "site-cell-template",
          gcType: "String",
          gcSubType: "RelatedRecord",
          width: 220,
          gcExport: ["SiteCode", "SiteName"],
        },
        {
          gcLabel: "Site Code",
          gcType: "String",
          dataField: "SiteCode",
          sortOrder: "asc",
          width: 120,
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Site Name",
          gcType: "String",
          dataField: "SiteName",
          width: 140,
          gcSubType: "HiddenDescription",
        },
        {
          gcLabel: "Grade",
          gcType: "String",
          dataField: "Grade",
          width: 100,
        },
        {
          gcLabel: "Net Kg",
          gcType: "Decimal-4-2",
          dataField: "NetWeight",
          allowFiltering: false,
        },
        {
          gcType: "String",
          gcSubType: "IconButton",
          cellTemplate: "menu-cell-template",
          cssClass: "more-menu",
          allowFixing: true,
          fixedPosition: "right",
          fixed: true,
          showInColumnChooser: false,
        },
      ]);
    },
    dataSourceConfig() {
      return CustomerService.dataSourceConfig(
        "api/AlmondIntakeBinInStockList",
        {
          select: [
            "SeasonYear",
            "BinCardNo",
            "BinCardNoAsString",
            "BranchCode",
            "BranchName",
            "ProductCode",
            "ProductName",
            "InStock",
            "LocationCode",
            "LocationName",
            "SiteCode",
            "SiteName",
            "Grade",
            "NetWeight",
          ],
          filter: ["InStock", "=", 1],
          // sort: [{ selector: "Code", desc: false }],
        }
      );
    },
    seasonYearsDs() {
      var max = new Date().getFullYear();
      var min = max - 29;
      var years = [];

      for (var i = max; i >= min; i--) {
        years.push(i);
      }
      return years;
    },
    filterFormItems() {
      let formFields = [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "SeasonYear",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Season",
              editorOptions: {
                dataSource: this.seasonYearsDs,
                showClearButton: true,
              },
            },
            {
              dataField: "BinCardNoAsString",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Card",
              editorOptions: {
                dataSource: CustomerService.dataSourceConfig(
                  "api/AlmondIntakeBinInStockList",
                  {
                    sort: [{ selector: "BinCardNo", asc: true }],
                    select: ["BinCardNoAsString"],
                  }
                ),
                valueExpr: "BinCardNoAsString",
                displayExpr: "BinCardNoAsString",
                showClearButton: true,
                searchExpr: ["BinCardNoAsString"],
                searchMode: "contains",
                searchEnabled: true,
              },
            },
            {
              dataField: "BranchCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Branch",
              editorOptions: {
                dataSource: CustomerService.dataSourceConfig("api/Branch", {
                  filter: [["Inactive", "=", "N"]],
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                showClearButton: true,
                itemTemplate: "item-template",
              },
            },

            {
              dataField: "ProductCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Product",
              editorOptions: {
                dataSource: CustomerService.dataSourceConfig(
                  "api/SaleItemCompanyBranch",
                  {
                    filter: [
                      ["CompanyCode", "=", this.model.CompanyCode],
                      ["BranchCode", "=", this.model.BranchCode],
                      ["ItemType", "=", "S"],
                      // ["SalesUM", "=", this.model.SalesUM],
                      ["Inactive", "=", "N"],
                      ["AvailableForSale", "=", "Y"],
                      ["Status", "=", "A"],
                    ],
                    select: [
                      "ItemCode",
                      "Description",
                      "Inactive",
                      "SalesUM",
                      "BranchCode",
                      "CompanyCode",
                    ],
                  }
                ),
                valueExpr: "ItemCode",
                displayExpr: "Description",
                searchExpr: ["ItemCode", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                showClearButton: true,
                itemTemplate: "product-cell-template",
              },
            },
            {
              dataField: "LocationCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Location",
              editorOptions: {
                dataSource: CustomerService.dataSourceConfig(
                  "api/BinLocation",
                  {
                    sort: [{ selector: "Location", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Location",
                searchExpr: ["Code", "Location"],
                searchMode: "contains",
                searchEnabled: true,
                showClearButton: true,
                itemTemplate: "bin-location-template",
              },
            },
            {
              dataField: "SiteCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Site",
              editorOptions: {
                dataSource: [
                  { SiteCode: "E", SiteName: "E" },
                  { SiteCode: "I", SiteName: "In Transit" },
                  { SiteCode: "S", SiteName: "Lyrup" },
                  { SiteCode: "A", SiteName: "Renmark" },
                ],
                valueExpr: "SiteCode",
                displayExpr: "SiteName",
                searchExpr: ["SiteCode", "SiteName"],
                searchMode: "contains",
                searchEnabled: true,
                showClearButton: true,
                itemTemplate: "site-template",
              },
            },
            {
              dataField: "Grade",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Grade",
              editorOptions: {
                dataSource: ["A", "B", "C", "D", "E", "I", "P", "Z"],
                showClearButton: true,
              },
            },
          ]),
        },
      ];

      return formFields;
    },
  },
  methods: {
    async transferBin() {
      if (!this.transferBinModel.ToBranch) {
        this.$nextTick(function() {
          alert(
            `"To Branch" has not been selected and the transaction has not been processed. The "To Branch" should be set to the active control`,
            "Validation Errors"
          );
        });
        return;
      }
      let payload = this.getSavePayload();

      this.showLoading(true);
      // get the parent row data of  intake bin list grid for this transfer to fetch the from branch details
      let rowData = this.transferBinDataSourceConfig[0];
      let toBranch = branchDataSource
        .items()
        .find((x) => x.Code == payload.ToBranchCode);

      await IntakeBinListService.save(payload)
        .then(() => {
          this.showLoading(false);
          this.$notify(
            `Card # ${rowData.BinCardNo} has been transferred from Branch ${rowData.BranchCode} - ${rowData.BranchName} to ${toBranch.Code} - ${toBranch.Description}.`,
            "success"
          );
          this.transferBinPopupVisible = false;
          this.dataSourceConfig.reload();
        })
        .catch(async (error) => {
          this.showLoading(false);
          if (error.data.length && error.data.length > 0) {
            await this.displayServerError(error, "Bin Transfer Save Failed");
          }
          // HACK:: check if a concurrent transfer processing for the same BinCardNo is processed. and if so, need to show message and then reload the underlying grid data
          else if (
            error.data.error.message &&
            JSON.parse(error.data.error.message)[0].ErrorMessage.endsWith(
              "has been acted on."
            )
          ) {
            await this.displayServerError(error, "Bin Transfer Save Failed");
            this.transferBinPopupVisible = false;
            this.dataSourceConfig.reload();
          } else {
            this.displayServerError(error, "Bin Transfer Save Failed");
          }
        });
    },

    getSavePayload() {
      let payload = {
        DateIn: this.transferBinModel.DateIn.toSaveDate(),
        BranchCode: this.transferBinModel.FromBranch,
        ToBranchCode: this.transferBinModel.ToBranch,
        StockTransferDetails: [],
      };

      payload.StockTransferDetails = this.transferBinDataSourceConfig.map(
        (row) => {
          let newRow = {};
          newRow.TransferQty = row.NetWeight;
          newRow.ItemCode = row.ProductCode;
          newRow.BinCardNo = row.BinCardNo;
          newRow.SeasonYear = row.SeasonYear;
          return newRow;
        }
      );

      return payload;
    },
    popUpBackButtonClick() {
      this.transferBinPopupVisible = false;
    },
    transferBinHidden() {
      this.transferBinModel.ToBranch = "";
      this.$refs["intake-bin-list"].instance.refresh();
    },
    // eslint-disable-next-line no-unused-vars
    async applyFilter(filterCollection, filterField, e) {
      let filterCollection2 = [...filterCollection];

      filterCollection2.push(["InStock", "=", 1]);

      if (filterCollection2.length == 0) {
        var grid = this.$refs["intake-bin-list"].instance;
        grid.clearFilter();
      } else {
        this.dataSourceConfig.filter(filterCollection2);
      }

      this.dataSourceConfig.load();
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        searchPanel,
        exportButton,
        columnChooserButton,
        // {
        //   location: "after",
        //   locateinmenu: "auto",
        //   widget: "dxButton",
        //   options: {
        //     validationGroup: "formsData",
        //     icon: "filter",
        //     elementAttr: { id: "filter-btn" },
        //     onClick: () => {
        //       this.showRightContainer = !this.showRightContainer;
        //       var item = document.getElementById("filter-btn");

        //       item.classList.add("dx-state-invisible");

        //       var grid = this.$refs["intake-bin-list"].instance;
        //       grid.repaint();
        //     },
        //     visible: !this.showRightContainer,
        //   },
        // },
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            elementAttr: { id: "filter-btn" },
            icon: "filter",
            onClick: () => {
              this.showFilterRightContainer = !this.showFilterRightContainer;
              var grid = this.$refs["intake-bin-list"].instance;
              grid.repaint();
            },
            visible: !this.showFilterRightContainer,
          },
        }
      );
    },
    onAddClickHandler() {
      this.$logger.trackEventButtonClickAddNew();
      this.$router.push({
        path: `/customer/create`,
      });
    },
    onSelectionChanged({ selectedRowsData }) {
      this.$router.push({
        path: `/customer/review/${selectedRowsData[0].Code}`,
      });
    },
    async onBinListContextMenuItemClick(e) {
      if (e.itemData.menuText == "Transfer Bin") {
        let rowData = e.itemData.data.data;

        this.transferBinDataSourceConfig = [];
        this.transferBinDataSourceConfig.push(rowData);
        this.transferBinModel.FromBranch = rowData.BranchCode;
        await branchDataSource.load();
        this.branchDataSourceConfig = branchDataSource
          .items()
          .filter((branch) => branch.Code != rowData.BranchCode);

        this.transferBinPopupVisible = true;

        this.$logger.debug("onBinListContextMenuItemClick", rowData);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.action-button {
  margin-left: 10px;
}

.footer-actions {
  display: flex;
  justify-content: flex-end;
}

.transfer-bin-toolbar {
  height: 65px;
}

.transfer-bin-form {
  margin-top: 25px;
}
</style>
